export default __webpack_public_path__ + "static/media/gil_bolutin.97e41cee.jpg";